<template>
  <select
    v-model="value"
    class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md dark:bg-gray-900 dark:text-white dark:placeholder-gray-300"
    :class="classes"
  >
    <slot />
  </select>
</template>

<script setup>
import { computed } from 'vue'
import { errorClasses } from '../common'

const props = defineProps({
  modelValue: [Object, String, Number],
  error: String,
})

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})

const classes = computed(() => errorClasses(props.error))
</script>
